export default __webpack_public_path__ + "1d8f7bc81e1b4193482d62c338b0b418.svg";